import React, { useEffect, useState } from 'react'
import { Country, State, City } from 'country-state-city';
import csc from 'country-state-city';
import Api from '../../Api/Api'
import { AiFillDelete, AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import NavBar from '../Navbar'

function EditAddress() {

  const [first, setFirst] = useState(true)
  const [address, setAddress] = useState(false)
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState(false)
  const [totalQuantity, setTotalQuantity] = useState(false)

  const [allCountries, setAllCountries] = useState(false)
  const [allStates, setAllStates] = useState(false)
  const [allCities, setAllCities] = useState(false)


  const [object, setObject] = useState({
    Name: "",
    Address_Line_1: "",
    Address_Line_2: "",
    Pin_Code: "",
    Contact_Number: "",
    Country: false,
    State: false,
    City: false
  })

  let history = useHistory();
  const { id } = useParams();





  const countries = Country.getAllCountries();

  const updatedCountries = countries.map((country) => ({
    label: country.name,
    value: country.isoCode,
  }));

  const updatedStates = (countryId) =>
    State
      .getStatesOfCountry(countryId)
      .map((state) => ({ label: state.name, value: state.isoCode }));

  const updatedCities = (countryId, stateId) =>
    City
      .getCitiesOfState(countryId, stateId)
      .map((city) => ({ label: city.name, value: city.name }));


  const setCountry = (e) => {
    setObject((p) => {
      return { ...p, Country: e.target.value, State: null, City: null }
    })
  }
  const setState = (e) => {
    setObject((p) => {
      return {
        ...p, State: e.target.value, City: null
      }
    })
  }
  const setCity = (e) => {
    console.log(e.target.value);
    setObject((p) => {
      return {
        ...p, City: e.target.value
      }
    })
  }

  const handleChange = (e) => {
    setObject((p) => {
      return {
        ...p,
        [e.target.name]: e.target.value
      }
    })
  }

  useEffect(() => {
    const getAddress = async () => {
      try {
        let { data } = await Api.getAddress(id);
        console.log(data);
        let newData = data
        const countryIndex = updatedCountries.findIndex((x) => x.label === data.Country)
        newData.Country = updatedCountries[countryIndex].value
        const states = State.getStatesOfCountry(newData.Country);
        const stateIndex = states.findIndex((x) => x.name === data.State)
        newData.State = states[stateIndex].isoCode
        setObject(data)
      } catch (e) {
        console.log(e);
      }
    }
    getAddress()
  }, [id])

  useEffect(() => {
    setAllCountries(updatedCountries)
  }, [])

  useEffect(() => {
    setAllStates(updatedStates(object.Country))
  }, [object.Country])

  useEffect(() => {
    setAllCities(updatedCities(object.Country, object.State))
  }, [object.State, object.Country])


  const handleSave = async () => {
    console.log(object);
    if ((object.Name === "") || (object.Address_Line_1 === "") || (object.Pin_Code === "") || (object.Contact_Number === "") ||
      !object.Country || !object.State || !object.City) {
      alert("Fill all required fields")
      return
    }
    try {
      const newObject = object
      const countryData = Country.getCountryByCode(object.Country)
      const stateDate = State.getStateByCodeAndCountry(object.State, object.Country)
      newObject.Country = countryData.name
      newObject.State = stateDate.name
      const data = await Api.updateAddress(id, newObject);
      setObject({
        Name: "",
        Address_Line_1: "",
        Address_Line_2: "",
        Pin_Code: "",
        Contact_Number: "",
        Country: false,
        State: false,
        City: false
      })
      console.log(data);
      history.push("/cartaddress");

    } catch (e) {
      console.log(e);
    }
  }

  const handleBack = (e) => {
    history.push("/cartaddress");

  }

  return (
    <>
      <NavBar />
      <div className='container'>
        <div className="row bg-light container rounded mt-5 mb-3">
          <h2 className='my-4 text-center'><b>Edit Address</b></h2>
          <div className='col-12'>
            <div className="form-floating mb-3">
              <input onChange={handleChange} name='Name' value={object.Name} className='mb-3 form-control form-control' type="text" placeholder="name" />
              <label for="floatingInput">Name*</label>
            </div>
            <div className="form-floating mb-3">
              <input onChange={handleChange} name='Address_Line_1' value={object.Address_Line_1} className='mb-3 form-control' type="text" placeholder="Address1" />
              <label for="floatingInput">Address Line 1*</label>
            </div>
            <div className="form-floating mb-3">
              <input onChange={handleChange} name='Address_Line_2' value={object.Address_Line_2} className='mb-3 form-control' type="text" placeholder="Address2" />
              <label for="floatingInput">Address Line 2<small>(optional)</small></label>
            </div>

            <label for="email">Country*</label>
            <select class="form-select mb-3"
              aria-label="Country"
              value={object.Country}
              onChange={setCountry}
            >
              {allCountries && allCountries?.map((i) => (
                <option value={i.value}>{i.label}</option>
              ))}
            </select>
            <label for="email">State*</label>
            <select class="form-select mb-3"
              aria-label="State"
              value={object.State}
              onChange={setState}
            >
              {allStates && allStates.map((i) => (
                <option value={i.value}>{i.label}</option>
              ))}
            </select>

            <label for="email">City*</label>
            <select class="form-select mb-4"
              aria-label="State"
              value={object.City}
              onChange={setCity}
            >
              {allCities && allCities.map((i) => (
                <option value={i.value}>{i.label}</option>
              ))}
            </select>
            <div className="form-floating mb-3">
              <input onChange={handleChange} name='Pin_Code' value={object.Pin_Code} className='mb-3 form-control' type="text" placeholder="Pincode" />
              <label for="floatingInput">Pincode*</label>
            </div>
            <div className="form-floating mb-3">
              <input onChange={handleChange} name='Contact_Number' value={object.Contact_Number} className='mb-3 form-control' type="text" placeholder="Phone" />
              <label for="floatingInput">Phone*</label>
            </div>
            <div className="text-center d-flex mb-4 justify-content-between">
              <button className="btn btn-danger px-4 h5" onClick={handleBack} style={{ borderRadius: "1rem" }}><b>Back</b></button>
              <button className="btn btn-success px-4 h5" onClick={handleSave} style={{ borderRadius: "1rem" }}><b>Save</b></button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EditAddress